const styles = {
  card: {
    backgroundColor: "white",
    mb: 2,
    borderRadius: "20px",
    boxShadow: 0,
  },
};
export default styles;
